import { useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';

// redux
import { mapDispatchProps, mapStateToProps } from '../../../../store/store';
import { connect } from 'react-redux';
import { ROUTES } from '../../../../routes';
import { useNavigate } from 'react-router';
import API from '../../../../api';

import Fetcher from '../../../../libraries/fetcher';
import OnAfterModalClosed from '../../../../libraries/onAfterModalClosed';
import ResourceOrderer from '../resourceOrderer';
import { useLanguage } from '@languages/index';

const SNSOrderVideo = (props: any) => {
  const language = useLanguage();
  const languageTexts = { ...language.common, ...language.pages.sns };
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const onAfterModalClosed = new OnAfterModalClosed(props);

  // brand
  const fetchBrandRes = useQuery({
    queryKey: ['fetch_brand'],
    queryFn: async () => {
      try {
        const res = await API.Brand.show({ brandToken: props.auth.token });
        props.setBrand(res.data.brand);

        return res;
      } catch (error) {
        props.showModal({
          hideCloseButton: true,
          text: languageTexts.celeb_detail_text_1,
        });
      }
    },
  });
  if (
    fetchBrandRes.data &&
    fetchBrandRes.data.brand &&
    fetchBrandRes.data.brand.hasExperiencedSnsInstall &&
    !fetchBrandRes.data.brand.snsPassInstalledAt
  ) {
    navigate(ROUTES.SNS_PAYMENT_COMPLETE.PATH);
  }

  const countVideosRes = useQuery({
    queryKey: ['count_videos:published', fetchBrandRes.data?.brand?.id],
    queryFn: async () => {
      try {
        const res = await API.BrandSns.countVideos({
          brandToken: props.auth.token,
          where: { is_published: true },
        });
        return res.data.count;
      } catch (error) {
        props.showModal({
          hideCloseButton: true,
          text: languageTexts.celeb_detail_text_2,
        });
      }
    },
    enabled: !!fetchBrandRes.data,
  });

  // fetcher
  const videosFetcherRes = useQuery({
    queryKey: ['get_videos_fetcher:published', fetchBrandRes.data?.brand?.id],
    queryFn: () =>
      new Fetcher(async (offset: number, limit: number) => {
        const res = await API.BrandSns.fetchVideos({
          brandToken: props.auth.token,
          where: { is_published: true },
          offset,
          limit,
        });
        return res.data.reviews;
      }),
    enabled: !!fetchBrandRes.data,
  });
  const removeFetcherQueries = () => {
    queryClient.removeQueries({
      queryKey: [`get_videos_fetcher:published`],
      exact: false,
    });
  };

  useEffect(() => {
    return () => {
      queryClient.removeQueries({
        queryKey: ['count_videos:published'],
        exact: false,
      });
      removeFetcherQueries();
    };
  }, []);

  return (
    <ResourceOrderer
      resourceName={languageTexts.index_text_7}
      resourceCount={countVideosRes.data || 0}
      fetcher={videosFetcherRes.data}
      initialFetchCount={18}
      adderForMore={18}
      makeItemTagFunc={(rsrc) => (
        <div>
          <img
            className="object-cover aspect-[1.7796] w-full h-full"
            src={`http://img.youtube.com/vi/${rsrc.videoKey}/mqdefault.jpg`}
          />
        </div>
      )}
      updateOrderFunc={async (ids) => {
        const res = await API.BrandSns.orderVideos({
          brandToken: props.auth.token,
          masterToken: props.auth.masterToken,
          ids,
        });
        removeFetcherQueries();
      }}
    />
  );
};

export default connect(mapStateToProps, mapDispatchProps)(SNSOrderVideo);
